/* eslint-disable react-hooks/exhaustive-deps */
import '../../styles/pricing-table.scss';
import * as React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { get } from 'lodash';
import PaymentServices from 'services/payment';
import { useHistory } from 'react-router';
import Cookies from 'js-cookie';
import { STRIPE_PRICE_NAME } from 'constants/common';
import { routers } from 'router/router';
import { 
  PriceGradMapStarter,
  PriceSilverPlusMonth, 
  PriceSilverPlusYear,
  PriceGoldMonth,
  PriceGoldYear,
} from './components/StripePrices';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { getStudent } from 'app/authorization/authorizationSlice';
import { getAccessToken, getUserRole, removeAccessToken, removeUserId } from 'utils/sessionStorage';

interface Props {}

const Payment = (props: Props) => {
  const [studentEmail, setStudentEmail] = React.useState('');
  // const [showTrial, setShowTrial] = React.useState(false);
  const dispatch = useAppDispatch();
  const personalStore = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const student_id = personalStore?.student_id;
  const role  = personalStore?.user_role ?? '';

  // Populated by the login flow (FormLogin.tsx dispatches getStripeSubscriptionInfo
  // before redirecting here). Used only to show a friendly notice below — new sign-ups
  // never hit this state since registration auto-activates the free Starter plan.
  const stripeSubscriptionInfo = useAppSelector((store: any) => store.basicInformation.stripeSubscriptionInfo);

  let history = useHistory();
  const params = new URLSearchParams(history.location.search);  
  let priceName = params.get('price')  || ''; 
  const canceled = params.get('canceled')  || '';

  const [selectPrice, setSelectPrice] = useState(1);
  const [showAllPrice, setShowAllPrice] = useState(true);
  const [showMontly, setShowMonthly] = useState(true);

  let studentId = Cookies.get('request_id') || '';
  const token = getAccessToken();
  let isLogin:boolean = token ? true : false;

  // "" plan means the login-time subscription check came back with no record at
  // all (see FormLogin.tsx's subcription_plan === '' redirect) — e.g. a Stripe
  // subscription that was removed directly on the Stripe Dashboard. Only shown
  // for a logged-in redirect; brand-new sign-ups never land here in this state.
  const subcriptionPlan = stripeSubscriptionInfo
    ? (get(stripeSubscriptionInfo, 'payload.subcription_plan', '') || get(stripeSubscriptionInfo, 'subcription_plan', ''))
    : null;
  const showNoActiveSubscriptionNotice = isLogin && stripeSubscriptionInfo != null && subcriptionPlan === '';

  if (canceled==='true') {
    let price = Cookies.get('price') || '';
    if (price) {
      priceName = price;
    }      
  }

  // When user cancels Stripe checkout, redirect back to dashboard with correct role
  useEffect(() => {
    if (canceled !== 'true' || !isLogin) return;
    const userRole = role || getUserRole();
    if (userRole) {
      history.replace({
        pathname: routers.dashBoard.path,
        search: `?role=${userRole}`,
      });
    }
  }, [canceled, isLogin, role]);

// useEffect(() => {
//   const link = document.createElement('link');
//   link.rel = 'stylesheet';
//   link.href = '/assets/css/pricing-table.css';
//   document.head.appendChild(link);
//   return () => {
//     document.head.removeChild(link);
//   };
// }, []);

  useEffect(() => {
    const getInfo = async(studentId:any) => {
      if (isLogin && student_id) {
        studentId = student_id;
        const res = await dispatch(getStudent(studentId)).unwrap();
        
        console.log('studentInfo:', res);

        // let trial_count = res?.trial_count ?? 0;
        // setShowTrial(trial_count === 0);
        setStudentEmail(res?.email ?? '');

      }
      else {
        setStudentEmail(Cookies.get('userEmail') || '');
        // setShowTrial(true);
      }

      if (studentId===''){
        history.push(routers.login.path);
      }     

      switch(priceName){
        // case 'silver_month':
        //   setShowAllPrice(false);
        //   setShowMonthly(true);
        //   setSelectPrice(1);
        //   Cookies.set("price", priceName);
        //   break;
        case STRIPE_PRICE_NAME.GradMapStarter:
          setShowAllPrice(false);
          setShowMonthly(true);
          setSelectPrice(35);
          Cookies.set("price", priceName);
        break;
        case 'silver_plus_month':
          setShowAllPrice(false);
          setShowMonthly(true);
          setSelectPrice(5);
          Cookies.set("price", priceName);
          break;
        case 'gold_month':
          setShowAllPrice(false);  
          setShowMonthly(true);
          setSelectPrice(2);
          Cookies.set("price", priceName);
          break;
        // case 'silver_year':
        //   setShowAllPrice(false);
        //   setShowMonthly(false);
        //   setSelectPrice(3);
        //   Cookies.set("price", priceName);
        //   break;
        case 'silver_plus_year':
          setShowAllPrice(false);
          setShowMonthly(false);
          setSelectPrice(6);
          Cookies.set("price", priceName);
          break;
        case 'gold_year':
          setShowAllPrice(false);
          setShowMonthly(false);
          setSelectPrice(4);
          Cookies.set("price", priceName);
          break;
        default:
          setShowAllPrice(true);
          Cookies.set("price", '');
      }
    }

    getInfo(studentId);
  }, []);


    //#region Create Fixed Column - Setting Menu
    React.useEffect(() => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.innerHTML = `
      document.body.style.overflow = "auto";
        `;
      document.body?.appendChild(script);
    }, []);
    //#endregion
    

  // const onSelectSilverMonth = (n:number) => {
  //   setSelectPrice(1);
  // }
  // const onSelectSilverYear = (n:number) => {
  //   setSelectPrice(3);
  // }
  // const onSelectGoldMonthTrial = (n:number) => {
  //   setSelectPrice(12);
  // }
  // const onSelectSilverPlusMonthTrial = (n:number) => {
  //   setSelectPrice(25);
  // }

  const onSelectGradMapStarter = (n:number) => {
    setSelectPrice(35);
  }  
  const onSelectSilverPlusMonth = (n:number) => {
    setSelectPrice(5);
  }
  const onSelectSilverPlusYear = (n:number) => {
    setSelectPrice(6);
  }
  const onSelectGoldMonth = (n:number) => {
    setSelectPrice(2);
  }
  const onSelectGoldYear = (n:number) => {
    setSelectPrice(4);
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    const domainUrl = `${window.location.origin}`;
    let trialDays = 0; // No trial
    let price_Name = '';
    switch(selectPrice) 
    {
      // case 1:
      //   price_Name = STRIPE_PRICE_NAME.SilverMonth;
      //   break;
      case 2:
        price_Name = STRIPE_PRICE_NAME.GoldMonth;
        break;
      // case 12:
      //   price_Name = STRIPE_PRICE_NAME.GoldMonth;
      //   trialDays = 14;
      //   break;
      // case 3:
      //   price_Name = STRIPE_PRICE_NAME.SilverYear;
      //   break;
      case 4:
        price_Name = STRIPE_PRICE_NAME.GoldYear;
        break;
      case 5:
        price_Name = STRIPE_PRICE_NAME.SilverPlusMonth;
        break;
      case 25:
        price_Name = STRIPE_PRICE_NAME.SilverPlusMonth;
        trialDays = 14;
        break;
      case 35:
        price_Name = STRIPE_PRICE_NAME.GradMapStarter;
        break;
      case 6:
        price_Name = STRIPE_PRICE_NAME.SilverPlusYear;
        break;     
      }
    if (price_Name) {
      try {
        const checkoutUrl = await PaymentServices.createCheckoutSession(domainUrl, price_Name, trialDays, studentId, studentEmail);
        if (checkoutUrl) {
          window.location.replace(`${checkoutUrl}`);
        }
        else {
          console.log('Error creatting the Checkout Url.');
        }
      }
      catch(er){
        console.log('Error: ', er);
      }
    }
  };  
  
  const handleLogout = () => {
    if (window.Intercom) {
      window.Intercom('shutdown');
    }
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    Cookies.remove('request_id');
    Cookies.remove('price');
    history.push(routers.login.path);
  };
    
  return (    
<form id="payment-form" onSubmit={handleSubmit}>
<div className='row'>
 
  <div className="pb-5 col-md-12 col-12">
      {(!isLogin) && (
        <div className="row w-100 px-5 pt-md-3" style={{ minHeight: '58px' }}>
          <div className='col-md-12 d-flex mx-3 flex-wrap justify-content-between align-items-center'>
            <div className='d-flex'>
              <button className="btn btn-back" 
                  style={{color:"#fff", backgroundColor: "#4d88f0", position:'absolute', left: '3em', top: '2em'}}
                  onClick={()=>{window.history.back();}}>&laquo; Back</button>

                <img src={'/assets/images/logo-color.svg'}
                  alt="GradMap logo"
                  style={{ alignSelf: 'center', paddingLeft:'100px' }}
                  height={48}
                  className="d-inline mx-3 pointer"
                  onClick={() =>
                    history.push({
                      pathname: routers.dashBoard.path,
                      search: `?role=${role}`,
                    })
                  }
                />
            </div>
            <span className="mt-2"><span> Already a member ?</span>
            <Button
              className="p-0 mx-1 pb-1"
              onClick={() => history.push(routers.login.path)}
              variant="link"
            >
              Login
            </Button>
            
            </span>
          </div>
        </div>
      )}
      {(isLogin) && (
        <div className="row w-100 px-5 pt-md-3" style={{ minHeight: '58px' }}>
          <div className='col-md-12 d-flex mx-3 flex-wrap justify-content-between align-items-center'>
            <div className='d-flex'>
              <button className="btn btn-back" 
                  style={{color:"#fff", backgroundColor: "#4d88f0", position:'absolute', left: '3em', top: '2em'}}
                  onClick={()=>{window.history.back();}}>&laquo; Back</button>

                <img src={'/assets/images/logo-color.svg'}
                  alt="GradMap logo"
                  style={{ alignSelf: 'center', paddingLeft:'100px' }}
                  height={48}
                  className="d-inline mx-3 pointer"
                  onClick={() =>
                    history.push({
                      pathname: routers.dashBoard.path,
                      search: `?role=${sessionStorage.getItem('userRole')}`,
                    })
                  }
                />
            </div>
            <span className="mt-2"><span>Already login ?</span>
            <Button
              className="p-0 mx-1 pb-1"
              onClick={handleLogout}
              variant="link"
            >Logout</Button>                       
            </span>
          </div>
        </div>
      )}
      
      {showNoActiveSubscriptionNotice && (
        <div className="row w-100 px-5 mt-4">
          <div className="col-md-12">
            <Alert variant="warning" className="mb-0 text-center">
              We could not find an active subscription on your account. Select a plan below to continue.
              {' '}If you believe this is a mistake, contact{' '}
              <a href="mailto:support@gradmap.com">support@gradmap.com</a>.
            </Alert>
          </div>
        </div>
      )}
      <div className='row'>
          <div className="col-md-12 mx-5 px-5 mt-5 d-flex justify-content-left">
            <h1>Payment</h1>
          </div>
      </div>
      <div className='row'>
          <div className="col-md-12 mx-5 px-5 d-flex justify-content-center">
            <div className="radio-block">
              <input type="radio" name="monthly" id="monthly-on" checked={showMontly} onChange={()=>{
                  setShowMonthly(true);
                  switch(selectPrice){
                    // case 3:
                    //   setSelectPrice(1);
                    //   break;
                    case 4:
                      setSelectPrice(2);
                      break;
                    case 6:
                      setSelectPrice(5);
                      break;
                  }
              }} />
              <label className="on-label"  htmlFor="monthly-on">Monthly</label>
              <input type="radio" name="monthly" id="monthly-off" checked={!showMontly} onChange={()=>{
                  setShowMonthly(false);
                  switch(selectPrice){
                    // case 1:
                    //   setSelectPrice(3);
                    //   break;
                    case 2:
                      setSelectPrice(4);
                      break;
                    case 5:
                      setSelectPrice(6);
                      break;
                  }
                }} />
              <label className="off-label" htmlFor="monthly-off">Yearly</label>
              <span className="selected" aria-hidden="true"></span>
            </div>
          </div>
          <div className='col-12 '>
            <div className='price-box mt-4'>
                <div className="PricingTable is-whiteButtonText is-lightColorBackground flex-container direction-column justify-content-center align-items-center">
                    <div className="PricingTable-grid direction-row">
                      {/* {showMontly && (showAllPrice || selectPrice===1) && (
                        <PriceSilverMonth onSelect={onSelectSilverMonth} isSelected={(selectPrice===1)} isRecommended={false} />
                      )} */}
                      {/* { showTrial && showMontly && (showAllPrice || selectPrice===25) && (
                        <PriceSilverPlusMonthTrial onSelect={onSelectSilverPlusMonthTrial} isSelected={(selectPrice===25)} isRecommended={true} />
                      )} */}
                      {showMontly && (showAllPrice || selectPrice===35) && (
                        <PriceGradMapStarter onSelect={onSelectGradMapStarter} isSelected={(selectPrice === 35)} isRecommended={true} updatePayment={false} subcripbeButton={true} />
                      )}
                      {showMontly && (showAllPrice || selectPrice===5) && (
                        <PriceSilverPlusMonth onSelect={onSelectSilverPlusMonth} isSelected={(selectPrice===5)} isRecommended={false} updatePayment={false} subcripbeButton={true} />
                      )}
                      {/* {showMontly && (showAllPrice || selectPrice===12) && (
                        <PriceGoldMonthTrial onSelect={onSelectGoldMonthTrial} isSelected={(selectPrice===12)} isRecommended={true} />
                      )}  */}
                      {showMontly && (showAllPrice || selectPrice===2) && (
                        <PriceGoldMonth onSelect={onSelectGoldMonth} isSelected={(selectPrice===2)} isRecommended={false} updatePayment={false} subcripbeButton={true} />
                      )}
                      {/* {!showMontly && (showAllPrice || selectPrice===3) && (
                        <PriceSilverYear onSelect={onSelectSilverYear} isSelected={(selectPrice===3)} isRecommended={false} />
                      )} */}
                      {!showMontly && (showAllPrice || selectPrice===6) && (
                        <PriceSilverPlusYear onSelect={onSelectSilverPlusYear} isSelected={(selectPrice===6)} isRecommended={false} updatePayment={false} subcripbeButton={true}  />
                      )}
                      {!showMontly && (showAllPrice || selectPrice===4) && (
                        <PriceGoldYear onSelect={onSelectGoldYear} isSelected={(selectPrice===4)} isRecommended={true} updatePayment={false} subcripbeButton={true} />
                      )} 
                    </div>
                </div>
          </div>
          </div>
      </div>
  </div>
  <style scoped>{`
#payment-form {
	overflow: auto;
}
    `}</style>
</div>
</form>   
  );
}

export default Payment;